import { environment as env } from "../../../../../environments/environment";

const BASE_API_URL = env.ApiUrl + "api/"; // env.apiGateWayAdmin;
const MAKS_API_URL = env.ApiUrl + "v1/";
// const ADMIN_BASE_API_URL = env.ApiUrl; // env.apiGateWayAdmin;

export const OPERATOR_ENDPOINTS = {
    base: BASE_API_URL,
    list: BASE_API_URL + "operator",
    listStatus: BASE_API_URL + "operator/status/{status}",
    item: BASE_API_URL + "operator/{id}",
    shortCode:
        BASE_API_URL +
        "organization/{companyId}/operator/{operatorId}/short_codes",
};

export const SHORT_CODE_ENDPOINTS = {
    mask: MAKS_API_URL + "mask",
    list: BASE_API_URL + "operator/{id}/short_codes",
    base: BASE_API_URL + "short_code",
    item: BASE_API_URL + "short_code/{id}",
};
